import React from "react";
import { Download, Filter as FilterIcon } from "lucide-react";

import { PetsReportController } from "../../../../services/controllers/reports";
import { usePetsReport } from "../../../../store/reports/usePetsReport";

import { Filter } from "../../../../components/ui/Filter";
import { CAMPO } from "../../../../components/ui/Filter/sizes";
import { Input } from "../../../../components/ui/Form/Input";
import { Select } from "../../../../components/ui/Form/Select";

export function PetsReportFilter() {
  const CPetsReport = PetsReportController();

  const filter = usePetsReport((st) => st.data.filter);
  const isLoading = usePetsReport((st) => st.data.isLoading);
  const total = usePetsReport((st) => st.data.pagination.totalDocuments);

  return (
    <Filter.Root onSubmit={CPetsReport.filterPets}>
      <Filter.Container>
        <Select.Root
          label="Tem pacote"
          style={CAMPO.medio}
          value={filter.hasPackage}
          onChange={(hasPackage) => CPetsReport.setFilter({ hasPackage })}
        >
          <Select.Option value="*">Todos</Select.Option>
          <Select.Option value="true">Sim</Select.Option>
          <Select.Option value="false">Não</Select.Option>
        </Select.Root>

        <Select.Root
          label="É assinante"
          style={CAMPO.medio}
          value={filter.isSubscriber}
          onChange={(isSubscriber) => CPetsReport.setFilter({ isSubscriber })}
        >
          <Select.Option value="*">Todos</Select.Option>
          <Select.Option value="true">Sim</Select.Option>
          <Select.Option value="false">Não</Select.Option>
        </Select.Root>

        <Select.Root
          label="Ausência"
          style={CAMPO.medio}
          value={filter.minAbsenceDays}
          onChange={(minAbsenceDays) => CPetsReport.setFilter({ minAbsenceDays })}
        >
          <Select.Option value="7">7d</Select.Option>
          <Select.Option value="15">15d</Select.Option>
          <Select.Option value="30">30d</Select.Option>
          <Select.Option value="45">45d</Select.Option>
          <Select.Option value="60">60d</Select.Option>
          <Select.Option value="90">90d</Select.Option>
        </Select.Root>

        <Input.Root
          label="CPF"
          mask="999.999.999-99"
          style={CAMPO.medio}
          value={filter.cpf}
          onChange={(cpf) => CPetsReport.setFilter({ cpf })}
        />

        <Input.Root
          label="Cliente ou pet"
          placeholder="Nome completo ou parte dele"
          style={CAMPO.busca}
          value={filter.search}
          onChange={(search) => CPetsReport.setFilter({ search })}
        />
      </Filter.Container>

      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
          Filtrar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="clear-pets-report"
                    disabled={isLoading}
          onClick={CPetsReport.clearFilter}
        >
          Limpar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="export-pets-report"
          title="Exportar para Excel"
          disabled={isLoading || !total}
          onClick={CPetsReport.reportExport}
        >
          <Filter.ActionIcon icon={Download} />
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
